export type NavItem = {
    id: string;
    label: string;
};

export type NavbarSocial = {
    id: 'github' | 'linkedin' | 'twitter' | 'email';
    label: string;
    href: string;
};

export type NavbarMock = {
    navItems: NavItem[];
    socials: NavbarSocial[];
    logoSrc: string;
    logoText: string;
    ctaLabel: string;
};

export const navbarMock: NavbarMock = {
    navItems: [
        { id: 'home', label: 'Home' },
        { id: 'about', label: 'About' },
        { id: 'services', label: 'Services' },
        // { id: 'projects', label: 'Projects' },
        { id: 'experience', label: 'Experience' },
    ],
    socials: [
        { id: 'github', label: 'GitHub', href: 'https://github.com/Mikirurk1' },
        { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/mykola-teriv/' },
        { id: 'email', label: 'Email', href: 'mailto:teriv168@gmail.com' },
    ],
    logoSrc: '/assets/logo/wihe_logo.png',
    logoText: 'Mykola',
    ctaLabel: 'Get in touch',
};
